import {get, isFunction, isArray} from "lodash";
import {Level} from "../../constans/levelTypes";
import moment from "moment";
import {getAddressString} from "../DevicesUtils";

export const getPrettyName = (device, placements = []) => {
    let name = placements.map((o) => o.name.slice(0).pop()).join(", ");
    if (name) name += ` (${device.Name} ${getAddressString(device)})`;
    else name = `${device.Name} ${getAddressString(device)}`;
    return name;
};

/**
 *
 * @param {function} t
 * @param {object|null} shadow
 * @param {object} [options]
 * @param {function|null} [options.filterCodes] filtrowanie kodow bledow np. dla danego wyjscia
 * @param {function} [options.transformData]
 * @param {object} [options.alertsInfo]
 * @param {Array<number|string>} [options.alertPriority]
 * @param {Array<number|string>} [options.warningPriority]
 * @returns {{warnings: (*[]|[]), errors: (*[]|[])}}
 */
export const translateWarningsAndErrors = (
    t,
    shadow,
    {
        filterCodes,
        transformData,
        alertsInfo,
        alertPriority,
        warningPriority,
    } = {}
) => {
    const getTranslatedCodes = (key, priority) => {
        try {
            if (shadow) {
                const codes = get(shadow, key, []).filter((code) => {
                    if (isFunction(filterCodes)) {
                        return filterCodes(code);
                    }
                    return true;
                });

                if (isArray(priority)) {
                    const priorityByCode = new Map();
                    priority.forEach((code, index) => {
                        const normalizedCode = +code;
                        if (!priorityByCode.has(normalizedCode)) {
                            priorityByCode.set(normalizedCode, index);
                        }
                    });
                    codes.sort((firstCode, secondCode) => {
                        const firstPriority = priorityByCode.get(+firstCode);
                        const secondPriority = priorityByCode.get(+secondCode);
                        if (firstPriority === undefined) {
                            return secondPriority === undefined ? 0 : 1;
                        }
                        if (secondPriority === undefined) return -1;
                        return firstPriority - secondPriority;
                    });
                }

                return codes.map((code) => {
                    const translated = t(
                        [
                            `notificationsCenter.errorCodes.S${code}`,
                            `notificationsCenter.errorCodes.${code}`,
                        ],
                        alertsInfo
                    );
                    return transformData
                        ? transformData({code: +code, translated})
                        : translated;
                });
            }
        } catch (e) {
            console.error(e);
        }
        return [];
    };
    return {
        errors: getTranslatedCodes("alertCodes", alertPriority),
        warnings: getTranslatedCodes("warningCodes", warningPriority),
    };
};

/**
 * @param placements
 * @param allowedSectorTypes
 * @return {null|*}
 */
export const getChamberFromPlacements = (placements, allowedSectorTypes) => {
    if (isArray(placements) && placements.length === 1) {
        if (placements[0]?.level === Level.CHAMBER) {
            if (isArray(allowedSectorTypes)) {
                if (allowedSectorTypes.includes(placements[0].SType)) {
                    return placements[0];
                }
            } else {
                return placements[0];
            }
        }
    }
    return null;
};

export const getSettlementText = ({DtaStartTime}) => {
    return `${moment.utc().startOf("day").diff(moment.utc(DtaStartTime).startOf("day"), "days") + 1} (${moment.utc(DtaStartTime).format("L")})`;
};

export const filterLocations = (
    ids,
    buildingsMap,
    extraFilter = () => true
) => {
    return ids
        .map((id) => buildingsMap.get(id))
        .filter((o) => !!o && extraFilter(o));
};
